import { createFileRoute } from '@tanstack/react-router'
import { requireRole } from '@/lib/auth-guards'
import { AdminHomePage } from '@/features/admin-home'

export const Route = createFileRoute('/_authenticated/admin-home')({
  beforeLoad: async () => {
    await requireRole('admin')
  },
  component: AdminHomePage,
})
